import React from 'react';
import { Button, HStack, Text } from '@chakra-ui/react';

const Paginacao = ({ currentPage, lastPage, total, onPageChange }) => {
    if (total === 0 || lastPage <= 1) {
        return null; 
    }

    const handlePageClick = (page) => {
        if (page >= 1 && page <= lastPage) {
            onPageChange(page);
        }
    };

    const renderPageButtons = () => {
        const buttons = [];
        const maxVisibleButtons = 5; 
        const createButton = (page) => (
            <Button
                key={`page-${page}`}
                size="sm"
                onClick={() => handlePageClick(page)}
                colorScheme={currentPage === page ? 'orange' : 'gray'}
                variant={currentPage === page ? 'solid' : 'outline'}
            >
                {page}
            </Button>
        );

        const createEllipsis = (key) => (
            <Text key={key} px={2} alignSelf="flex-end">...</Text>
        );

        if (lastPage <= maxVisibleButtons) {
            for (let i = 1; i <= lastPage; i++) {
                buttons.push(createButton(i));
            }
            return buttons;
        }

        buttons.push(createButton(1));

        if (currentPage > 3) {
            buttons.push(createEllipsis('start-ellipsis'));
        }

        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(lastPage - 1, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(createButton(i));
        }

        if (currentPage < lastPage - 2) {
            buttons.push(createEllipsis('end-ellipsis'));
        }
        buttons.push(createButton(lastPage));

        return buttons;
    };

    return (
        <HStack spacing={2} justify="center" mt={8} wrap="wrap">
            <Button
                size="sm"
                onClick={() => handlePageClick(currentPage - 1)}
                isDisabled={currentPage === 1}
            >
                Anterior
            </Button>
            {renderPageButtons()}
            <Button
                size="sm"
                onClick={() => handlePageClick(currentPage + 1)}
                isDisabled={currentPage === lastPage}
            >
                Próxima
            </Button>
        </HStack>
    );
};

export default Paginacao;
